/**
 * Badge Component - PouchPay Design System
 * Status badges with semantic color variants
 */

import React from 'react';
import { cn } from '@/lib/utils';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'success' | 'warning' | 'danger' | 'primary' | 'neutral';
  size?: 'sm' | 'md';
  children: React.ReactNode;
}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ variant = 'neutral', size = 'md', className, children, ...props }, ref) => {
    const variantClasses = {
      success: 'badge-success',
      warning: 'badge-warning',
      danger: 'badge-danger',
      primary: 'badge-primary',
      neutral: 'badge-neutral',
    };

    const sizeClasses = {
      sm: 'px-[var(--space-s)] py-[var(--space-xs)] text-[var(--font-size-label)]',
      md: 'px-[var(--space-m)] py-[var(--space-s)] text-[var(--font-size-body-s)]',
    };

    return (
      <span
        ref={ref}
        className={cn(
          'inline-flex items-center font-[var(--font-weight-medium)] rounded-[var(--radius-full)]',
          variantClasses[variant],
          sizeClasses[size],
          className
        )}
        {...props}
      >
        {children}
      </span>
    );
  }
);

Badge.displayName = 'Badge';

export default Badge;
